import styled from "styled-components";
import "../../../../styles/variables.css";
import Flex from "../../../Flex";

export const SuccessDescription = styled.div`
  margin: 15px 0 30px 0;
  text-align: center;
  a {
    text-decoration: none;
    color: var(--black);
  }
  label {
    line-height: 24px;
    color: var(--blue-30);
    border-bottom: 2px dashed var(--blue-30);
    &:hover {
      cursor: pointer;
      opacity: 0.9;
    }
  }
`;

export const BundleButtonWrapper = styled(Flex)`
  @media (max-width: 600px) {
    width: 80%;
    position: absolute;
    bottom: 20px;
  }
`;

export const MacroScoreTooltipContainer = styled.div`
  text-align: left;
  h3 {
    font-weight: 600;
    color: var(--black);
    font-family: "Poppins";
    margin: 0px;
    margin-bottom: 10px;
    font-size: var(--fs14);
  }
  span {
    text-align: left;
    color: var(--gray-60);
    font-size: var(--fs14);
  }
  a {
    color: var(--blue-20);
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;
